var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export var ImportJobStatusType;
(function (ImportJobStatusType) {
    ImportJobStatusType["Processed"] = "Processed";
    ImportJobStatusType["Closed"] = "Closed";
    ImportJobStatusType["Processing"] = "Processing";
    ImportJobStatusType["ErrorProcessing"] = "Error Processing";
    ImportJobStatusType["Reprocessing"] = "Reprocessing";
})(ImportJobStatusType || (ImportJobStatusType = {}));
//# sourceMappingURL=ImportJobStatusType.js.map